import React from "react";

const CalendarIcon = ({ theme }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4902_6190)">
        <path
          d="M4.6665 0V6.66667M15.3332 0V6.66667M1.99984 3.33333H17.9998C18.3535 3.33333 18.6926 3.47381 18.9426 3.72386C19.1927 3.97391 19.3332 4.31305 19.3332 4.66667V18C19.3332 18.3536 19.1927 18.6928 18.9426 18.9428C18.6926 19.1929 18.3535 19.3333 17.9998 19.3333H1.99984C1.64622 19.3333 1.30708 19.1929 1.05703 18.9428C0.80698 18.6928 0.666504 18.3536 0.666504 18V4.66667C0.666504 4.31305 0.80698 3.97391 1.05703 3.72386C1.30708 3.47381 1.64622 3.33333 1.99984 3.33333Z"
          stroke={theme === "dark" ? "white" : "#122549"}
        />
      </g>
      <defs>
        <clipPath id="clip0_4902_6190">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CalendarIcon;
